import React from 'react';
import styles from './FinancialSection.module.css';

/**
 * Bloco da aba Financeiro: subtítulo curto, uma linha de apoio e, à direita,
 * a ação ou o filtro do bloco. O título da aba fica no `AreaTitle`; os blocos
 * ficam um degrau abaixo, para a leitura seguir resumo -> pacotes -> atendimentos.
 */
function FinancialSection({ title, hint, actions, children }) {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <div className={styles.titles}>
          <h3 className={styles.title}>{title}</h3>
          {hint && <span className={styles.hint}>{hint}</span>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
      <div className={styles.body}>{children}</div>
    </section>
  );
}

export default FinancialSection;
